// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3mP0i","error":"Textarea_error__3_aVr","readonly":"Textarea_readonly__1PQ_6","disabled":"Textarea_disabled__2AM6Y"};